import { Injectable } from '@angular/core'
import { BalonML, Configuration, ConfigurationDataReturnType } from '@ct-fwh/fwh-balon-ml-typescript-sdk'
import { StorageService } from '../storage/storage.service'
import { environment } from '../../../../environments/environment'

const config = new Configuration(environment.microservices.balonML.appClientId, environment.microservices.balonML.name as any).load()

/**
 * Dont use this class directly. Use a shared instance of BalonMLSdkService instead
 * For authentication purposes only
 *
 **/
@Injectable({
    providedIn: 'root',
})
export class _BalonMLSdkWrapperService extends BalonML {
    protected balonMLConfig: ConfigurationDataReturnType

    constructor(idbState: StorageService) {
        super(idbState as any, config)
        this.balonMLConfig = config
    }
}